import React from 'react';

export const normalizeArtistCareerTimeline = (value) => {
  if (!Array.isArray(value)) return [];
  return value
    .map((item, index) => ({
      id: String(item?.id || `${index}-${item?.time_label || item?.timeLabel || item?.year || ''}-${item?.title || item?.label || ''}`),
      time_label: String(item?.time_label ?? item?.timeLabel ?? item?.year ?? '').trim(),
      title: String(item?.title ?? item?.label ?? '').trim(),
      note: String(item?.note ?? item?.memo ?? '').trim(),
    }))
    .filter((item) => item.time_label || item.title || item.note);
};

export default function ArtistCareerTimelineContent({
  title,
  entries,
  emptyText = 'まだ年表が設定されていません。',
  showTitle = true,
}) {
  const items = normalizeArtistCareerTimeline(entries);

  return (
    <>
      {showTitle ? (
        <div className="artist-career-modal__head">
          <h2>{title || 'アーティストの年表'}</h2>
        </div>
      ) : null}
      {items.length ? (
        <div className="artist-career-modal__list">
          {items.map((entry, index) => (
            <div key={entry.id || index} className="artist-career-modal__item">
              <div className="artist-career-modal__meta">
                <div className="artist-career-modal__time">{entry.time_label || '時期未設定'}</div>
                <div className="artist-career-modal__marker" aria-hidden="true" />
              </div>
              <div className="artist-career-modal__body">
                {entry.title ? (
                  <div className="artist-career-modal__title">{entry.title}</div>
                ) : null}
                {entry.note ? (
                  <div className="artist-career-modal__note">{entry.note}</div>
                ) : null}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="artist-career-modal__empty">{emptyText}</div>
      )}
    </>
  );
}
